// When REACT_APP_SERVER_URL is empty (e.g. Heroku same-origin deploy), use current origin in browser.
// On subdomain (e.g. ta.app.herokuapp.com), use root host for API so login/API work.
// No silent localhost:3001 fallback except when running the CRA dev server on port 3000.

const fromEnv = process.env.REACT_APP_SERVER_URL;
const fromEnvTrimmed = fromEnv && fromEnv.trim();
const sameOrigin = typeof window !== 'undefined' && window.location && window.location.origin;
const isLocalDev =
  typeof window !== 'undefined' &&
  window.location &&
  (window.location.origin === 'http://localhost:3000' ||
    window.location.origin === 'http://127.0.0.1:3000' ||
    (window.location.hostname.endsWith('.localhost') && window.location.port === '3000'));
const LOCAL_API_FALLBACK = 'http://localhost:3001';

function getServerUrl() {
  if (fromEnvTrimmed || fromEnv) return String(fromEnvTrimmed || fromEnv).trim();
  if (typeof window === 'undefined' || !window.location) return '';

  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const hasTenantSubdomain =
    parts.length >= 4 &&
    hostname !== 'localhost' &&
    hostname !== '127.0.0.1' &&
    !hostname.endsWith('.localhost');
  if (hasTenantSubdomain) {
    const rootHost = parts.slice(1).join('.');
    const protocol = window.location.protocol || 'https:';
    const port =
      window.location.port && window.location.port !== '80' && window.location.port !== '443'
        ? ':' + window.location.port
        : '';
    return `${protocol}//${rootHost}${port}`;
  }
  if (isLocalDev) return LOCAL_API_FALLBACK;
  return (sameOrigin || '').trim();
}
const serverUrl = getServerUrl();

// Optional: account whose events are shown on the public Event Calendar when no user is logged in.
// Create React App replaces process.env.REACT_APP_* at build time; avoid relying on process existing in browser.
const publicCalendarAccountId =
  (process.env.REACT_APP_PUBLIC_CALENDAR_ACCOUNT_ID && String(process.env.REACT_APP_PUBLIC_CALENDAR_ACCOUNT_ID).trim()) || null;

module.exports = {
  serverInfo: {
    serverUrl,
  },
  publicCalendarAccountId: publicCalendarAccountId || null,
};
